---
title: "Правила и условия"
path: "/ru/правила-и-условия"
seoTitle: "Правила и условия | Dutch Passion Thailand"
seoDescription: "Краткое изложение условий заказа, оплаты, доставки и возврата при покупке семян конопли Dutch Passion в Таиланде. Прочитайте перед заказом."
---

> **Эта русская версия — краткое изложение, выполненное машинным переводом.**
> Юридическую силу имеет только [англоязычная версия условий](/terms-and-conditions). При
> расхождениях преимущество имеет английский текст. Страница ожидает проверки носителем языка.

## Область применения

Эти условия действуют для всех заказов на dutchpassion.co.th. Подтверждая заказ, вы соглашаетесь
с ними.

## Заказ и оплата

Цены указаны в тайских батах и включают налог. Оплатить можно при получении, кредитной или
дебетовой картой, через PromptPay или мобильный банк. Данные карты передаются напрямую нашему
провайдеру Omise и никогда не проходят через этот сайт.

## Доставка

Заказы, оформленные до 15:00 в рабочий день, отправляются в тот же день. Упаковка анонимная:
снаружи ничто не указывает на содержимое. Доставка осуществляется только по Таиланду:
стандартная почтовая доставка стоит 100 THB по всей стране, включая Бангкок, и обычно занимает
1–3 рабочих дня. В Бангкоке доступна дополнительная опция — доставка в день заказа за 250 THB.

## Отмена и возврат

Пока заказ не отправлен, вы можете отменить или изменить его, написав нам и указав номер заказа.
Семена не подлежат возврату — вскрыта упаковка или нет, — и доставленные заказы не
возмещаются. Напишите нам, если товар пришёл с дефектом или не соответствует заказу.

## Применимое право

Эти условия регулируются законодательством Таиланда. Вопросы: info@dutchpassion.co.th.
